import Axios from 'axios'
import { isTraceabilityEnabled } from '@/utils/feature-toggle'

const traceabilityStatisticsService = {
  axios() {
    let AxiosInstance = Axios
    AxiosInstance.defaults.baseURL = process.env.TRACEABILITY_BASE_URL
    return AxiosInstance
  },
  getTraceabilityTotalStatus(filters = {}) {
    return this.axios().get('/exams/indicators', { params: filters })
  },
  getTraceabilityTotalDelayedExamsCount(filters = {}) {
    return isTraceabilityEnabled()
      ? this.axios().get('exams/delay/count', { params: filters })
      : Promise.resolve({ data: {} })
  },
  getTotalSamplesGoingToPlaceExecution(filters) {
    return filters
      ? this.axios().get('/exams/destiny/count', { params: filters })
      : this.axios().get('/exams/destiny/count')
  },
}

export default traceabilityStatisticsService
